<template>
	<div>
		<h2>Contratos</h2>
		<br>

        <h3> Ver tambien PRE-CONTRATOS Y FINALIZADOS &nbsp&nbsp<input type="checkbox" id="incluyePreFinalizados" v-on:click='cambioIncluye()'></h3>
        <br>
        
		<input type='text' placeholder='BUSCAR' v-model='abuscar'  >

	      <ul>
			<li><router-link id="agregar" :to="{name: 'agre-con'}">
				<br><br>Agregar Contrato o Pre-Contrato
			</router-link></li>

			<li><router-link id="edos" :to="{name: 'edos-de-cta'}">
				<br><br>Estados de Cuenta 
			</router-link></li>	

			<li><router-link id="impri" :to="{name: 'agre-for'}">
				<br><br>Imprimir Contrato o Pre-Contrato 
			</router-link></li>

            <li><router-link id="renovacion" :to="{name: 'cont-reno'}">
                <br><br>Renovación de contratos 
            </router-link></li>
		  </ul>

		<br>
		<br>

		<div id='contratos-lista' v-if="contratosTodos !=null" align='left' >
			<div v-for="contrat in buscando" >	
				<div v-if="verTodos == true || (verTodos == false && contrat.status == 'RENTADO')"  class="box ">
					<strong>
						<p>Contrato # {{contrat.id}}</p>
						<p>{{contrat.propiedad}}</p>
						<p>{{contrat.inquilino}}</p>
						<font color="blue">
                            <p v-if="contrat.familia">{{contrat.familia}}</p>  
                            <p v-if="contrat.subfamilia">Sub familia:{{contrat.subfamilia}}</p>
							<p>{{contrat.nombreComercial}}</p>
                            <p>{{contrat.giro}}</p>                            
							
						</font>
						<p>Renta mensual: $ {{formateaNumero(contrat.importeMes)}}</p>
                        <br>
						<p v-if="contrat.status != 'PRE-CONTRATO'">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp 
                            <font color="blue" v-if="contrat.status == 'RENTADO'">Status: {{contrat.status}} {{contrat.finalizo}}
                            </font>
                            <font color="red" v-if="contrat.status == 'FINALIZADO'">Status: {{contrat.status}} {{contrat.finalizo}}
                            </font>
                        </p>
						<p v-if="contrat.status == 'PRE-CONTRATO'">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp 
                            <font color="orange">Status: {{contrat.status}} {{contrat.finalizo}}
                            </font>
                        </p>

						<br>
						<p>INICIO CONTRATO: {{formateaFecha(contrat.fechaInicio)}}</p>
						<p>TERMINA CONTRATO: {{formateaFecha(contrat.fechaTerminacion)}}</p>
						<p><font color="red">{{vencido(contrat.fechaTerminacion, contrat.status)}}</font></p>

					</strong>
					<p>
					  	<router-link :to="{name: 'ver-con', params:{id:contrat.id}}">
                            <button class= "button is-primary"> Ver</button>
                        </router-link>&nbsp

					  	<router-link :to="{name: 'edo-con', params:{id:contrat.id}}" v-if="contrat.status != 'PRE-CONTRATO'">
                            <button class= "button is-primary"> Estado de Cuenta </button>
                        </router-link>&nbsp

					  	<router-link :to="{name: 'pago', params:{id:contrat.id, inum:contrat.inquilinoId, pnum:contrat.propiedadId , ino:contrat.inquilino , pno:contrat.propiedad , gir:contrat.giro, fam:contrat.familia , subf:contrat.subfamilia , dueno:contrat.dueno, mail:contrat.emailInquilino, rentaMes:contrat.importeMes} }" v-if="contrat.status != 'PRE-CONTRATO' && contrat.status == 'RENTADO' "> 
                            <button class= "button is-primary">Pagar </button>
                        </router-link>&nbsp
                        <br><br>

                        <div @click="verContrato(contrat.id) ">
                            <button class="button is-primary">Editar Contrato</button>
                        </div>

                        <div id="verIndi" v-if="verIndividual == true && cualContratoVer == contrat.id" align="center">
                            <button class= "button is-warning" @click="verIndividual = false">Cerrar</button>
                                <br><br>
                                <editar-individual  :cualContrato="numContrato" :vector="vector"  @cerrar="verIndividual = false" ></editar-individual>
                                <br><br>  
                        </div><br>

				    </p>
				</div>

			   
			</div>
            
		</div>
		<span v-else><button class="button is-primary is-loading">Loading ...</button></span>
	</div>
</template>


<script>
import axios from 'axios';
import EditarIndividual from './Contrato-editar.vue';

export default {
  name: 'Contratos',
  components:{
      EditarIndividual
  },  
  mounted(){
  	this.getContratos();
  },
  props: ['vector'],  
  data () {
    return {
      contratosTodos: null,
      abuscar:'',
      verIndividual: false,
      verTodos: false
    }
  },
  methods:{
  	getContratos(){
 		  		// checa si tiene autorizacion
  		if(!this.vector.includes('MASTERGGUV')){
	  		if(!this.vector.includes('Contratos')){
	  			alert('Seccion no autorizada');
	  			return;
	  		}
	  	}  		
  		axios.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php')
  		     .then((respuesta) => {
  		     	this.contratosTodos = respuesta.data;
  			 });


  	},

	vencido: function(fecha, status){

		var fecha1 = new Date(fecha); 
		fecha1.setHours(0); 

		var hoy = new Date(); 
		hoy.setHours(0);

		var fechams = fecha1.getTime(); // en milisegundos				
		var hoyms = hoy.getTime(); // en milisegundos
        var unMes = 30 * 24 * 60 * 60 * 1000;
        
        var diferencia = hoyms - fechams;

		if(fechams < hoyms){
			if(status == "FINALIZADO"){
				return ".";
			}
            return "CONTRATO VENCIDO EL " + this.formateaFecha(fecha) + ", HACE " + (diferencia/unMes).toFixed(0) + " MESES, FAVOR DE RENOVARLO";            
		} 

        // si no esta vencido entonces checa si vencera en dos meses o menos
        if((fechams - unMes - unMes) < hoyms ){
            return "CONTRATO POR VENCER EL " + this.formateaFecha(fecha) + " EN  " + (-diferencia/unMes).toFixed(0) + " MESES **";           
        } 

	},

	formateaFecha: function (fecha) {
		var d = new Date(fecha); 
		if (Date.parse(d)){
			// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
			d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
			d.setHours(0);
			var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
			d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
			return d} 
		else{return "sin fecha";}
	},
	
    formateaNumero(valor1) {
        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 2, useGrouping:true});
    },

    formateaNumeroSimple(valor1) {
        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 0});
    },

	fechaActual(){      
	    var currentDate = new Date() //hoy
	    var day = currentDate.getDate();
	    var month = currentDate.getMonth() + 1;
	    var year = currentDate.getFullYear();
	    var my_date = year+"-"+month+"-"+day;
	    return my_date;  
	},
    verContrato(num){
        this.numContrato = num;
        this.verIndividual = true;
        this.cualContratoVer = num;
    },
    cambioIncluye(){
        this.verTodos = !this.verTodos;
        this.getContratos(); 
    }

  },
  computed:{
 	buscando: function (){
  		return this.contratosTodos.filter((item) =>  
  			   item.propiedad.toUpperCase().includes(this.abuscar.toUpperCase()) 
  			|| item.inquilino.toUpperCase().includes(this.abuscar.toUpperCase()) 
  			|| item.familia.toUpperCase().includes(this.abuscar.toUpperCase()) 
  			|| item.giro.toUpperCase().includes(this.abuscar.toUpperCase()) 
  			|| item.id.toUpperCase().includes(this.abuscar.toUpperCase()) 
  			|| item.nombreComercial.toUpperCase().includes(this.abuscar.toUpperCase()) 
  		);
  	}
  }
}
</script>

<style >

</style>




// WEBPACK FOOTER //
// src/Contratos.vue